import { COLOR_PALETTE } from 'constants/ui';
import { getConditionalObject } from 'utils/data';

import { FieldRowVariant } from './FieldRow.constants';

export const fieldRowWrapperStyles = ({ isChanged, variant, bordered }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  ...getConditionalObject(bordered, {
    padding: '11px',
    border: ({ palette }) => `1px solid ${palette.divider}`,
    borderRadius: '8px',
  }),
  ...getConditionalObject(variant === FieldRowVariant.DATE, {
    justifyContent: 'space-between',
  }),
  ...getConditionalObject(isChanged, {
    backgroundColor: COLOR_PALETTE.ADDITIONAL[1],
  }),
});

export const fieldRowLabelStyles = {
  whiteSpace: 'nowrap',
};

export const fieldRowValueStyles = isChanged => ({
  ...getConditionalObject(isChanged, {
    color: COLOR_PALETTE.ADDITIONAL[2],
  }),
});
